import React from 'react'
import { Form } from "react-bootstrap"
import Col from "react-bootstrap/Col"

const TextAreaField = ({name, rows, placeholder, required, handlechange,labelClass, fieldClass, label, grpmd}) => (
  <Form.Group as={Col} md={grpmd} controlId="validation{name}">
    <div className="custom-float">
    { label
      ? <p className={`label-wrap ${labelClass}`}><Form.Label>{label}{required ? '*' : ''}</Form.Label></p>
      : ''
    }
    <Form.Control
      className={fieldClass}
      name={name}
      required={required}
      as="textarea"
      rows={rows}
      onChange={handlechange}
      placeholder={placeholder} 
    />
    </div>
  </Form.Group>
);

export default TextAreaField;